export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
                移动端阅读
              </h2>
              <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-6">
                随时随地畅享下拉式流畅阅读。手机端完美适配，无需安装，打开浏览器即可沉浸式追漫。
                支持离线缓存和夜间模式，让每一次阅读都舒适自在。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="w-full sm:w-auto px-6 py-2.5 bg-background-50 text-primary-600 font-medium rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm">
                  <i className="ri-apple-line mr-2"></i>
                  iOS 版
                </button>
                <button className="w-full sm:w-auto px-6 py-2.5 bg-background-50/20 text-background-50 font-medium rounded-full border border-background-50/30 hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer text-sm">
                  <i className="ri-android-line mr-2"></i>
                  Android 版
                </button>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-48 h-72 md:w-56 md:h-80 rounded-2xl overflow-hidden border-4 border-background-50/20 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20mobile%20phone%20mockup%20showing%20a%20colorful%20manga%20reading%20app%20interface%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20vertical%20scrolling%20comic%20layout%2C%20modern%20UI%20design%2C%20flat%20illustration%20style%2C%20no%20text%20no%20letters%2C%20soft%20lighting%2C%20minimal%20background&width=560&height=800&seq=manga-app-mock&orientation=portrait"
                  alt="谜妹漫画移动端阅读界面"
                  title="谜妹漫画移动端 - 韩漫日漫国漫免费在线阅读"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}